import { useSWRConfig } from "swr";
import { APIEndpointEnum } from "../enums/endpoint";

type SwrMutate = ReturnType<typeof useSWRConfig>["mutate"];

const REFRESH_DELAYS_MS = [1500, 4000, 8000, 15000];

const ACCOUNT_RELATED_ENDPOINTS = [
  APIEndpointEnum.ACCOUNT,
  APIEndpointEnum.PORTFOLIO,
  APIEndpointEnum.TRANSACTION_HISTORY,
] as const;

const isAccountRelatedKey = (key: unknown): boolean => {
  if (!Array.isArray(key)) return false;
  return (ACCOUNT_RELATED_ENDPOINTS as readonly unknown[]).includes(key[0]);
};

/**
 * Trigger an immediate SWR revalidation of the account-related caches, plus
 * a series of follow-up revalidations to catch the value once the backend has
 * indexed a recent on-chain deposit/withdraw. The on-chain tx confirming does
 * not mean the API has indexed it yet — a single mutate() right after
 * `tx.wait()` typically returns the *old* balance.
 *
 * Fire-and-forget: timers run on the global window and are intentionally NOT
 * tied to any component's lifetime, so the balance keeps refreshing even after
 * the originating modal unmounts.
 */
export function scheduleAccountRefresh(mutate: SwrMutate): void {
  const trigger = () => {
    void mutate(isAccountRelatedKey, undefined, { revalidate: true });
  };
  trigger();
  REFRESH_DELAYS_MS.forEach((delay) => {
    window.setTimeout(trigger, delay);
  });
}
